const state = () => ({
  attackingTransition: 0,
  defensiveTransition: 0,
  goalkeeperInPossession: 0,
});

const mutations = {
  updateCounter (state, counter) {
    state.attackingTransition = counter ? 1 : 0;
  },

  updateHoldShape (state, holdShape) {
    state.attackingTransition = holdShape ? -1 : 0;
  },

  updateCounterPress (state, counterPress) {
    state.defensiveTransition = counterPress ? 1 : 0;
  },

  updateRegroup (state, regroup) {
    state.defensiveTransition = regroup ? -1 : 0;
  },

  updateDistributeQuickly (state, value) {
    state.goalkeeperInPossession = value ? 1 : 0;
  },

  updateSlowPaceDown (state, value) {
    state.goalkeeperInPossession = value ? -1 : 0;
  },
}

export default {
  state,
  mutations
};
